<nav class="mobile-nav">
  <button
    data-testid="btn-mobile-home"
    type="button"
    class="mobile-nav__route"
    aria-label="Home"
    [class.mobile-nav__route--active]="isHomeActive()"
    (click)="goHome()"
    (keydown.enter)="goHome()">
    <icon-display iconName="home" [height]="24" [width]="24" />
  </button>
  <button
    data-testid="btn-mobile-messages"
    type="button"
    class="mobile-nav__route"
    aria-label="Messages"
    [class.mobile-nav__route--active]="isMessagesActive()"
    (click)="goMessages()"
    (keydown.enter)="goMessages()">
    <icon-display iconName="message" [height]="24" [width]="24" />
  </button>
  <button
    data-testid="btn-mobile-history"
    type="button"
    class="mobile-nav__route"
    aria-label="History"
    [class.mobile-nav__route--active]="isHistoryActive()"
    (click)="goHistory()"
    (keydown.enter)="goHistory()">
    <icon-display iconName="document-search" [height]="24" [width]="24" />
  </button>
</nav>
